export enum TagColor {
  BLUE = 'blue',
  GREEN = 'green',
  GREY = 'grey',
  RED = 'red',
  WHITE = 'white',
  YELLOW = 'yellow',
}

export type TTagColor =
  | TagColor.RED
  | TagColor.GREEN
  | TagColor.BLUE
  | TagColor.YELLOW
  | TagColor.WHITE
  | TagColor.GREY;
